import styled from '@emotion/styled'
import { Card } from '../card/cardStyles'
import { CollapsePanel } from 'view/components/panels'
import { DialogRow } from 'view/components/inputs'
import { IconLabel } from 'view/components/icons/IconLabel'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'

// Header

export const TicketHeader = styled.div`
  flex: 0 0 20px;
  padding: 3px 5px 0 5px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);

  & ${DialogRow}, & ${DialogRow} * {
    color: white;
    font-size: 11px;
  }
  & ${DialogRow} div {
    border: 0;
    padding: 0;
  }
  & ${DialogRow} span {
    align-items: flex-start;
  }
`

// Fields

export const TicketFields = styled.div`
  flex: 1;
  overflow-y: scroll;

  & > * {
    margin-bottom: 1px;
  }

  ::-webkit-scrollbar {
    display: none;
  }
`

export const SummaryCollapsePanel = styled(CollapsePanel)`
  & > div > button {
    background-color: ${constants.CORE_PRIMARY};
  }

  & > div > button > span {
    color: ${constants.CORE_PRIMARY_6};
  }
`

export const CollapseContentWrapper = styled.div`
  padding: 20px;

  ${DialogRow}:not(:last-of-type) {
    margin-bottom: 19px;
  }
`

export const DeltaIconContainer = styled.span`
  ${mixins.deltaLabel};
  display: flex;
  align-items: center;
  font-family: inherit;
`

// Narrative Bar

export const TicketNarrativeBar = styled.div<{ revertible?: boolean }>`
  flex: 0 0 26px;
  display: flex;
  justify-content: ${props => (props.revertible ? 'space-between' : 'center')};
  align-items: center;
  padding: 0px 8px;
  border-bottom: 1px solid ${constants.CORE_PRIMARY_3};
  font-size: 11px;
  color: ${constants.CORE_PRIMARY_6};
`

// Footer

export const TicketFooter = styled.div`
  flex: 0 0 48px;
  display: flex;
  align-items: center;
  padding: 10px;

  label {
    cursor: inherit;
    font-size: 11px;
  }

  button {
    font-size: 11px;
  }
`

export const ActionIcon = styled(IconLabel)<{ isCancel?: boolean }>`
  label {
    font-weight: ${constants.FontWeight.SemiBold};
  }
  svg {
    color: ${props => (props.isCancel ? constants.CORE_PRIMARY_5 : 'inherit')};
  }
`

// Content

export const TicketContainer = styled.div<{ statusColor: string; completed?: boolean; fixedSize?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 480px;
  width: 100%;
  min-height: 517px;
  max-height: ${props => (props.fixedSize ? 'calc(100vh - 200px)' : 'none')};
  border: 4px solid ${props => props.statusColor};
  border-top-width: ${props => (props.completed ? '0px' : '4px')};

  ${TicketHeader} {
    background-color: ${props => props.statusColor};
  }
  ${Card} {
    flex: 0 0 80px;
    box-shadow: none;
  }
  ${TicketFields},
  ${TicketNarrativeBar} {
    border-top: 1px solid ${props => props.statusColor};
  }
`

export const EmptyTicket = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`
